import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { httpinstance } from "../../axios/api"

export const getairbookinghistory = createAsyncThunk('getairbookinghistory', async (newpage)=>{
    try{
        const url = `bookinghistory_for_air?page=${newpage}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})


export const getairbookinghistorysearch = createAsyncThunk('getairbookinghistorysearch', async (queryId)=>{
    console.log(queryId);
    try{
        const url = `bookinghistory_for_air/${queryId}`
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})
export const getoceanbookinghistory = createAsyncThunk('getoceanbookinghistory', async (query)=>{
    try{
        const url = 'bookinghistory_for_ocean'
        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})

export const getcancelhistory = createAsyncThunk('getdeletebooking', async ()=>{
    try{
        const url = 'getdeletebooking'
        const response = await httpinstance.get(url)
        console.log(response);
        return response
    }catch (err){
        return err.response
    }
})
export const getcancelhistorysearch = createAsyncThunk('getdeletebookingsearch', async (queryId)=>{
    try{
        const url = `getdeletebooking${queryId}`
            //   const url = `getdeletebooking?search=${encodeURIComponent(query)}`; // ✅ query param
    //   const url = `getdeletebooking?search=${encodeURIComponent(queryId)}`; // ✅ correct

        const response = await httpinstance.get(url)
        return response
    }catch (err){
        return err.response
    }
})
export const getsinglebookingdata = createAsyncThunk('getsinglebookingdata', async (values)=>{
    try{
        const url = 'single_booking_data'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})

/**
 * True when a getsinglebookingdata result means "this booking isn't yours to
 * see". The backend answers a queryId belonging to another account with
 * `{ success: "error", message: "Booking not found", statusCode: 404 }` — it
 * deliberately doesn't distinguish "missing" from "someone else's", so a 404
 * here is an authorisation failure as far as the UI is concerned.
 *
 * The thunk above swallows the axios error and returns `err.response`, so the
 * failure arrives as a normal fulfilled payload — callers must test for it
 * rather than relying on `.catch()`. Network failures leave `err.response`
 * undefined, which falls through to false so they keep their existing
 * "failed to load" handling instead of being mislabelled as unauthorised.
 *
 * @param {Object} [payload] - the thunk's `res.payload` (an axios response)
 * @returns {boolean}
 */
export const isBookingAccessDenied = (payload) => {
    if (!payload) return false
    const status = payload?.status ?? payload?.data?.statusCode
    if (status === 404) return true
    const message = payload?.data?.message
    return typeof message === 'string' && message.trim().toLowerCase() === 'booking not found'
}
export const getsinglecancelbookingdata = createAsyncThunk('getsinglecancelbookingdata', async (values)=>{
    try{
        const url = 'getdeletebyid'
        const response = await httpinstance.post(url,values)
        return response
    }catch (err){
        return err.response
    }
})

// Cancels an ocean booking. Hits DELETE /api/deletebooking with the booking's
// queryId + the user-entered cancellation reason. The request is a DELETE with
// a body, so axios needs it under `data`. thunkAPI.signal is forwarded to axios
// so callers can abort the in-flight request via dispatch(...).abort().
export const deletebooking = createAsyncThunk('deletebooking', async ({ queryId, reason }, thunkAPI)=>{
    try{
        const url = 'deletebooking'
        const response = await httpinstance.delete(url,{
            data: { queryId, reason },
            signal: thunkAPI.signal,
        })
        return response
    }catch (err){
        return err.response
    }
})
const initialState = {
    bookinghistorydata : {},
    bookingDetailPageData : {},
}

const bookingHistorySlice = createSlice({
    name : 'bookinghistoryslice',
    initialState,
    extraReducers:{

    }
})

export const getsavedbookingdata = state => state.bookinghistory.bookingDetailPageData;
export default bookingHistorySlice.reducer